import {
  postData,
  getData,
  putData,
  getDataGuest,
} from 'src/utils/axios/index';
import { urlMap } from 'src/utils/urls';

export const fetchCandidates = async (
  organizationId,
  page,
  rowsPerPage,
  payload,
) => {
  const url = `${urlMap.getCandidates}`
    .replace(`{org-id}`, organizationId)
    .replace(`{limit}`, rowsPerPage)
    .replace(`{page_number}`, page);
  return postData(url, payload);
};

export const fetchCandidatesByJobId = async (
  organizationId,
  jobOpeningId,
  rowsPerPage,
  page,
  payload,
) => {
  const url = `${urlMap.getCandidatesByJobId}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId)
    .replace(`{limit}`, rowsPerPage)
    .replace(`{page_number}`, page);
  return postData(url, payload);
};

export const getCandidatesSummary = async (organizationId, jobOpeningId) => {
  const url = `${urlMap.getCandidatesSummary}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId);
  return getData(url);
};

export const CreateCandidate = async (payload, organizationId) => {
  const url = `${urlMap.addCandidate}`.replace(`{org-id}`, organizationId);
  return postData(url, payload);
};

export const editCandidateDetails = async (
  organizationId,
  candidateId,
  reqBody,
) => {
  const url = `${urlMap.editCandidateDetails}`
    .replace(`{org-id}`, organizationId)
    .replace(`{candidate-id}`, candidateId);
  return postData(url, reqBody);
};

export const getCandidateDetails = async (
  organizationId,
  candidateId,
  token,
) => {
  const url = `${urlMap.getCandidateDetails}`
    .replace(`{org-id}`, organizationId)
    .replace(`{candidate-id}`, candidateId);
  return getData(url, token);
};

export const getCandidatesFilterSummary = async organizationId => {
  const url = `${urlMap.getCandidatesFilterSummary}`.replace(
    `{org-id}`,
    organizationId,
  );
  return getData(url);
};

export const getFilteredCandidates = async (
  organizationId,
  limit,
  pageNumber,
  payload,
) => {
  const url = `${urlMap.getFilteredCandidates}`
    .replace(`{org-id}`, organizationId)
    .replace(`{limit}`, limit)
    .replace(`{page_number}`, pageNumber);
  return postData(url, payload);
};

export const getCandidateDetailsByJobId = async (
  organizationId,
  jobOpeningId,
  candidateId,
  token,
) => {
  const url = `${urlMap.getCandidateDetailsByJobId}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId)
    .replace(`{candidate-id}`, candidateId);
  return getData(url, token);
};

export const getFilteredCandidateListByJobId = (
  organizationId,
  jobOpeningId,
  payload,
) => {
  const url = `${urlMap.getFilteredCandidateListByJobId}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId)
    .replace(`{limit}`, 100)
    .replace(`{page_number}`, 1);

  return postData(url, payload);
};

export const bulkCandidateAction = async (
  organizationId,
  jobOpeningId,
  reqBody,
) => {
  const url = `${urlMap.bulkCandidateAction}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId);
  return postData(url, reqBody);
};

export const bulkCandidateEmail = async (
  organizationId,
  jobOpeningId,
  reqBody,
) => {
  const url = `${urlMap.bulkCandidateEmail}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobOpeningId);
  return postData(url, reqBody);
};

export const getPreScreeningQuestions = async (jobId, userId, token) => {
  const url = `${urlMap.getPreScreeningQuestions}`
    .replace(`{job-opening-id}`, jobId)
    .replace(`{user-id}`, userId);
  return getData(url, token);
};

export const shortlistCandidates = async (jobId, reqBody) => {
  const url = `${urlMap.shorlistCandidate}`.replace('{job-opening-id}', jobId);
  return postData(url, reqBody);
};

export const getInpersonInterviewDetails = async (jobId, userId) => {
  const url = `${urlMap.getInpersonInterviewDetails}`
    .replace(`{job-opening-id}`, jobId)
    .replace(`{user-id}`, userId);
  return getData(url);
};

export const createInpersonInterview = async (jobId, userId, reqBody) => {
  const url = `${urlMap.createInpersonInterview}`
    .replace('{job-opening-id}', jobId)
    .replace('{user-id}', userId);
  return postData(url, reqBody);
};
export const updateInpersonInterview = async (jobId, userId, reqBody) => {
  const url = `${urlMap.updateInpersonInterview}`
    .replace('{job-opening-id}', jobId)
    .replace('{user-id}', userId);
  return putData(url, reqBody);
};

export const rejectCandidate = async (orgId, jobId, userId, reqBody) => {
  const url = `${urlMap.rejectCandidate}`
    .replace('{org-id}', orgId)
    .replace('{job-opening-id}', jobId)
    .replace('{user-id}', userId);
  return postData(url, reqBody);
};
export const hireCandidate = async (orgId, jobId, userId, reqBody) => {
  const url = `${urlMap.hireCandidate}`
    .replace('{org-id}', orgId)
    .replace('{job-opening-id}', jobId)
    .replace('{user-id}', userId);
  return postData(url, reqBody);
};

export const getPublicSharingLink = async (jobId, userId) => {
  const url = `${urlMap.getPublicSharingLink}`
    .replace('{job-opening-id}', jobId)
    .replace('{user-id}', userId);
  return getData(url);
};

export const getCandidateDetailsById = async (candidateId, token) => {
  const url = `${urlMap.getCandidateDetailsById}`.replace(
    '{candidate-id}',
    candidateId,
  );
  return getData(url, token);
};

export const getCandidateSources = async orgId => {
  const url = `${urlMap.getCandidateSources}`.replace(`{org-id}`, orgId);

  return getData(url);
};

export const addCandidateSource = async (orgId, payload) => {
  const url = `${urlMap.addCandidateSource}`.replace(`{org-id}`, orgId);

  return postData(url, payload);
};

export const updateCandidateFlag = async (orgId, jobId, userId, payload) => {
  const url = `${urlMap.updateCandidateFlag}`.replace(`{org-id}`, orgId).replace(`{job-opening-id}`, jobId).replace(`{user-id}`, userId);

  return postData(url, payload);
};

